import React from 'react'
import { Route, Routes as Router } from 'react-router-dom'
import { StepsContextProvider } from '../contexts/StepsContext'
// import { getAuth } from '../service'
import { BrandForm, OneInstructions, Questions, TwoInstructions } from '../views'
import Result from '../views/Result'
import Chat from '../views/chat/Chat'

export default function Routes(): React.ReactElement {
	return (
		<Router>
			<Route path="/introducao" element={<OneInstructions />} />
			<Route path="/instrucoes" element={<TwoInstructions />} />
			<Route path="/chat" element={<Chat />} />

			<Route
				path="/quizz"
				element={
					<StepsContextProvider>
						<Questions />
					</StepsContextProvider>
				}
			/>

			<Route path="/" element={<BrandForm />} />
			<Route path="/resultado" element={<Result />} />
		</Router>
	)
}
